export const errorTranslations = {
  "invalid token: token decoding failed: the token has expired":
    "トークンの期限が切れました。",
  "app not found": "アプリ情報は正しくありません。",
  "user exists with same email": "既にこのメールアドレスは登録されています。",
  "keycloak user exists with same email":
    "既にこのメールアドレスは登録されています。",
  "user with the same internal_email already exists in the tenant":
    "既にこのメールアドレスは登録されています。",
  "user not found": "ユーザーがKeycloakに存在していません。",
  "user not found with id": "電話帳が存在していません。",
  "user couldn't be deleted": "ユーザーがKeycloakに存在していません。",
  "user with the same phone number exists in database":
    "電話番号が重複しています。",
  "user exists with same username":
    "同じユーザーIDのユーザーが既に存在します。",
  "missing parameter: login_id and login_password are required":
    "ユーザーidとパスワードは必須です。",
  "error-invalid-email": "無効なメールアドレス。",
  "kana name カナはカタカナのみ使用できます。":
    "氏名カナはカタカナのみ使用可能です。",
  "first kana name かな名はひらがなのみ使用できます。":
    "氏名はひらがなのみ使用可能です。",
  "first kana name can only contain hiragana characters.":
    "氏名は英数字、ハイフンのみ使用可能です。",
  "last kana name can only contain hiragana characters.":
    "氏名は英数字、ハイフンのみ使用可能です。",
  "first furigana name can only contain hiragana characters.":
    "氏名ふりがな名はひらがなのみ使用可能です。",
  "last furigana name can only contain hiragana characters.":
    "氏名ふりがな名はひらがなのみ使用可能です。",
  "name can only contain alphanumeric characters, japanese characters, and hyphens.":
    "氏名は英数字、日本語文字、ハイフンのみ使用できます。",
  "personal tel invalid phone number format":
    "有効な電話番号形式(10, 11数字のみ)で入力してください。",
  "personal tel invalid interal user phone number format":
    "数字のみで入力してください。",
  "company tel invalid phone number format":
    "有効な電話番号形式(10, 11数字のみ)で入力してください。",
  "company home page is invalid": "URLの形式が正しくありません。",
  "personal tel can't be blank": "電話番号を入力してください。",
  "first name name is blank": "名前を入力してください。",
  "validation failed: name can't be blank": "名前を入力してください。",
  "validation failed: kana name can't be blank":
    "名前（カナ）を入力してください。",
  "invalid password: minimum length":
    "無効なパスワード：最低でも8文字以上である必要があります。",
  "validation failed: postcode can't be blank": "郵便番号を入力してください。",
  "validation failed: address can't be blank": "住所を入力してください。",
  "validation failed: url can't be blank": "URLを入力してください。",
  "something happened. when create yobery broadcast-group":
    "同じ名称のグループが既に存在します。",
  "an unexpected error occurred while updating password":
    "パスワードの更新中に予期しないエラーが発生しました。",
  "couldn't find role with 'id'=1": "該当するロールが見つかりませんでした。",
  "no available licenses for yobely":
    "YOBELYの利用ユーザー数がライセンス上限に達しています。",
  "no available licenses for kakely":
    "KAKELYの利用ユーザー数がライセンス上限に達しています。",
  "no available licenses for workjoy":
    "WorkJoyの利用ユーザー数がライセンス上限に達しています。",
  "unable to find contract for app yobely": "YOBELYは未契約です。",
  "unable to find contract for app kakely": "KAKELYは未契約です。",
  "unable to find contract for app workjoy": "WorkJoyは未契約です。",
  "license status for yobely is no contract": "YOBELYは未契約です。",
  "license status for kakely is no contract": "KAKELYのライセンスは未契約です",
  "license status for workjoy is no contract": "WorkJoyは未契約です。",
  "cannot register department without position":
    "役職なしでは部署を登録できません",
  "cannot set kakely license number lower than current users":
    "ご利用中のKAKELYユーザー数より少ないライセンス数に変更することはできません",
  "cannot set yobely license number lower than current users":
    "ご利用中のYOBELYユーザー数より少ないライセンス数に変更することはできません",
  "cannot set workjoy license number lower than current users":
    "ご利用中のWorkJoyユーザー数より少ないライセンス数に変更することはできません",
  "http 405 method not allowed": "ユーザーがKeycloakに存在していません。",
  "validation failed: first kana name フリガナは英字とハイフンのみ使用できます":
    "氏名は英数字、ハイフンのみ使用可能です。",
  "validation failed: last kana name フリガナは英字とハイフンのみ使用できます":
    "氏名は英数字、ハイフンのみ使用可能です。",
  "validation failed: first furigana name かな名はひらがなのみ使用できます。":
    "氏名はひらがなのみ使用可能です。",
  "validation failed: last furigana name かな名はひらがなのみ使用できます。":
    "氏名はひらがなのみ使用可能です。",
  "validation failed: personal tel invalid phone number format":
    "有効な電話番号形式(10, 11数字のみ)で入力してください。",
  "cannot delete own user": "自分自身のユーザーは削除できません",
  "Personal tel user exists with same phone number":
    "電話番号が重複しています。",
  "personal tel user exists with same phone number":
    "電話番号が重複しています。",
  "validation failed: personal tel user exists with same phone number":
    "電話番号が重複しています。",
  "user exists with same phone number": "電話番号が重複しています。",
  "insufficient access for resource role":
    "管理者ロールに変更する権限が不足しています。",
  "cannot update own account attribute: role":
    "自分自身のロールを更新することはできません。",
  "cannot create resource with administrator permissions":
    "管理者権限を持つリソースを作成することはできません。",
  'bad request: {"error":"invalidpasswordMinspecialcharsmessage","error_description":"invalid password: must contain at least 1 special characters."}':
    "無効なパスワード：少なくとも1つの特殊文字を含める必要があります。",
  'bad request: {"error":"invalidpasswordMinlengthmessage","error_description":"invalid password: minimum length 8."}':
    "無効なパスワード：最低でも8文字以上である必要があります。",
  'bad request: {"error":"invalidpasswordMinuppercasecharsmessage","error_description":"invalid password: must contain at least 1 upper case characters."}':
    "無効なパスワード：少なくとも1つの大文字を含める必要があります。",
  'bad request: {"error":"invalidpasswordMindigitsmessage","error_description":"invalid password: must contain at least 1 numerical digits."}':
    "無効なパスワード：少なくとも1つの数字を含める必要があります。",
  'bad request: {"error":"invalidpasswordMinlowercasecharsmessage","error_description":"invalid password: must contain at least 1 lower case characters."}':
    "無効なパスワード：少なくとも1つの小文字を含める必要があります。",
  'bad request: {"error":"invalidPasswordMinLengthMessage","error_description":"Invalid password: minimum length 8."}':
    "無効なパスワード：最低でも8文字以上である必要があります。",
  invalidPasswordMinSpecialCharsMessage:
    "無効なパスワード：少なくとも1つの特殊文字を含める必要があります。",
  invalidPasswordMinUpperCaseCharsMessage:
    "無効なパスワード：少なくとも1つの大文字を含める必要があります。",
  invalidPasswordMinLowerCaseCharsMessage:
    "無効なパスワード：少なくとも1つの小文字を含める必要があります。",
  invalidPasswordMinDigitsMessage:
    "無効なパスワード：少なくとも1つの数字を含める必要があります。",
  invalidPasswordMinLengthMessage:
    "無効なパスワード：最低でも8文字以上である必要があります。",
  "validation failed: email can't be blank":
    "メールアドレスを入力してください。",
  "validation failed: email is not a valid email":
    "有効なメールアドレスを入力してください。",
  "email is not a valid email": "無効なメールアドレス",
  "email is required for administrator users":
    "管理者ユーザーにはメールアドレスが必要です。",
  "validation failed: first furigana name can only contain hiragana characters.":
    "ふりがな名はひらがなのみ使用可能です。",
  "validation failed: personal tel is blank": "電話番号を入力してください。",
  "personal tel is blank": "電話番号を入力してください。",
  "last furigana name can only contain hiragana characters":
    "ふりがな名はひらがなのみ使用可能です。",
  'bad request: {"error":"invalidpasswordhistorymessage","error_description":"invalid password: must not be equal to any of last 3 passwords."}':
    "無効なパスワード: 過去に使用したパスワードは設定できません。",
  "couldn't find user without an id": "idを入力してください。",
  "tenant does not match user registered tenant":
    "登録されたテナントがユーザーのテナントと一致しません",
  "cannot alter values of user outside own tenant":
    "登録されたテナントがユーザーのテナントと一致しません",
  "contact history not found": "連絡履歴が見つかりません。",
  "login can only contain letters, numbers, dots, underscores, and hyphens":
    "ログインには、文字、数字、ドット、アンダースコア、ハイフンのみを使用できます。",
  "invalid password: must not be equal to any of last 3 passwords.":
    "無効なパスワード: 過去に使用したパスワードは設定できません。",
  "invalid password: must contain at least 1 special characters.":
    "無効なパスワード：少なくとも1つの特殊文字を含める必要があります。",
  "invalid password: minimum length 8.":
    "無効なパスワード：最低でも8文字以上である必要があります。",
  "invalid password: must contain at least 1 upper case characters.":
    "無効なパスワード：少なくとも1つの大文字を含める必要があります。",
  "invalid password: must contain at least 1 numerical digits.":
    "無効なパスワード：少なくとも1つの数字を含める必要があります。",
  "invalid password: must contain at least 1 lower case characters.":
    "無効なパスワード：少なくとも1つの小文字を含める必要があります。",
  "couldn't find app without an id": "アプリが見つかれませんでした",
  "login_id and login_password are required":
    "ユーザーidまたはパスワードを入力してください。",
  "failed to add user to job pool - delete flag set incorrectly":
    "削除フラグが正しく設定されていません",
  "tenant not found": "テナントが見つかれませんでした。",
  "invalid token: the token has expired": "トークンの期限が切れました。",
  "validation failed: last name can only contain alphanumeric characters, japanese characters, and hyphens.":
    "氏名は英数字、日本語文字、ハイフンのみ使用できます。",
  "tenant_department not found": "存在しない部署コードが指定されています。",
  "first name can only contain alphanumeric characters, japanese characters, and hyphens":
    "氏名は英数字、日本語文字、ハイフンのみ使用できます。",
  "first furigana name can only contain hiragana and katakana characters.":
    "かな名はひらがなとカタカナのみ使用できます。",
  "last furigana name can only contain hiragana and katakana characters.":
    "かな名はひらがなとカタカナのみ使用できます。",
  "failed to create user: first name can only contain alphanumeric characters, japanese characters, and hyphens.":
    "氏名は英数字、日本語文字、ハイフンのみ使用できます。",
  "name kana can only contain hiragana characters.":
    "かな名はひらがなのみ使用可能です。",
  "network error": "ネットワークエラーが発生しました。接続を確認してください。",
  "company fax invalid phone number format":
    "有効なFAX番号形式(10, 11数字のみ)で入力してください。",
  "unable to update tenant: name kana is invalid":
    "氏名（企業名ふりがな）は無効です。",
  "unable to update tenant: name is invalid": "企業名は無効です。",
  'Keycloak API error: {"error":"User not found","error_description":"For more on this error consult the server log at the debug level."}':
    "ユーザーがKeycloakに存在していません。",
  "insufficient access for resource password reset":
    "パスワードリセットの権限が不足しています。",
  "name is invalid":
    "企業名は漢字、カタカナ、ひらがな、英数字、記号のみ使用可能です。",
  "name kana is invalid": "かな名はひらがなのみ使用可能です。",
  "access denied for hazum api request":
    "Hazum APIリクエストのアクセスが拒否されました。",
  "something happened. when create yobely user":
    "YOBELYユーザーの作成中にエラーが発生しました。",
  "unexpected error: no host component for uri":
    "URIにホストコンポーネントがありません",
  "first name can only contain alphanumeric characters, japanese characters, and hyphens.":
    "氏名は英文字、日本語文字、ハイフンのみ使用できます。",
  "error deleting user from yobely: not found":
    "HAZUMからユーザーを削除する際にエラーが発生しました: 見つかりません",
  'HAZUM API error: {"status":422,"payload":null,"errors":{"code":"401","message":"Not Found specified staff_id(uuid)"}}':
    "YOBELYには指定されたスタッフid(uuid)が見つかりません",
  "failed to updated yobely user": "YOBELYユーザーの更新に失敗しました",
  "not found specified staff_id":
    "YOBELYには指定されたスタッフidが見つかりません",
  "failed to create user: login must be less than 10 characters":
    "ログインは10文字未満",
  "リクエストのパラメータの必須項目が入力されていないか、値が不正です。":
    "リクエストのパラメータの必須項目が入力されていないか、値が不正です。",
  "an error occurred: unable to update tenant: sub directory can only contain alphabet characters and numbers.":
    "サブディレクトリ名には英字と数字のみ使用できます",
  'HAZUM API error: {"status":404}':
    "YOBELYにはテナントまたはユーザーが見つかりませんでした。",
  "tcp connection failed to connect":
    "接続に失敗しました。接続を確認してください。",
  "error deleting store in hazum: access denied for hazum api request":
    "YOBELYリクエストのアクセスが拒否されました。",
  "store id not found in hazum": "指定されたYOBELYストアidが見つかりません",
  "cannot create user without broadcast group":
    "一斉発信グループなしではユーザーを作成できません",
  "failed to save hazum record": "YOBELYレコードの保存に失敗しました。",
  "sub directory not found for tenant":
    "サブディレクトリが見つかりませんでした。一斉発信グループ作成は不可能です。",
  "attempt to skip hazum api request on store with id registered":
    "YOBELYリクエストをスキップしようとしています。",
  "hazum_store_id not found":
    "YOBELY一斉発信グループidが見つかりませんでした。",
  "already exist yobely store": "YOBELY一斉発信グループは既に存在します。",
  "not found specified store_id":
    "YOBELYには指定された一斉発信グループidが見つかりません",
  "delete user assigned to store":
    "登録されたユーザーがいる一斉発信グループは削除できません。",
  "tenant department name has already been taken":
    "同じ名前の部署が既に存在しています。",
  "display order has already been taken":
    "同じコードの部署が既に存在しています。",
  "already exist yobely company": "YOBELY企業は既に存在します。",
  "tenant sip_node_server not found":
    "テナントのSIPノードサーバーが見つかりませんでした。",
  "tenant sip_incom_server not found":
    "テナントのSIPインカムサーバーが見つかりませんでした。",
  "code is already taken": "テナントidがすでに存在しています。",
  "could not obtain a connection from the pool":
    "ユーザーの作成処理中にエラーが発生しました。しばらくしてから再度お試しください。",
  "personal phone number or company phone number is required":
    "個人電話番号または会社電話番号のいずれかが必要です。",
  "depth of broadcast group exceeded":
    "一斉発信グループの階層が上限を超えています。",
  "broadcast group not found": "一斉発信グループが見つかりません。",
  "store not found in hazum": "HAZUMに指定されたテナントが見つかりません。",
  "access denied": "アクセスが拒否されました。",
  "cannot change user broadcast group to a different one":
    "一斉発信グループを変更することはできません。",
  "cannot create user without broadcast group id":
    "一斉発信グループなしではユーザーを作成できません。",
  "cannot delete broadcast group with registered users":
    "登録されたユーザーがいる一斉発信グループは削除できません。",
  "hazum is not configured for this tenant":
    "このテナントにはYOBELYが設定されていません。",
  "broadcast group name has already been taken":
    "同じ名前の一斉発信グループが既に存在します。",
  "failed to update yobely store": "YOBELY一斉発信グループの更新に失敗しました",
  "cannot change login id of user":
    "ユーザーのユーザーidを変更することはできません。",
  "user with the same full name already exists in the tenant":
    "氏名が重複しています。",
  "user with the same email already exists in the tenant":
    "メールアドレスが重複しています。",
  "user with the same personal tel already exists in the tenant":
    "個人電話番号が重複しています。",
  "既にこのメールアドレスは登録されています。":
    "メールアドレスが重複しています。",
  "error-person-name-invalid-character":
    "氏名は『-@.』以外の記号は使えません。",
  "parent tenant department with code not found":
    "親部署コードが見つかりませんでした。",
  "tenant department with id not found": "部署idが見つかりませんでした。",
  "duplicate display order in the same tenant":
    "同じコードの部署が既に存在しています。",
  "validation failed: description is too long (maximum is 1000 characters)":
    "部署概要は最大1000文字までです。",
  "company postal code is invalid": "有効な郵便番号形式で入力してください。",
  "name tenant department name has already been taken":
    "同じ名前の部署が既に存在しています。",
  "access denied for keycloak api request":
    "APIリクエストのアクセスが拒否されました。",
  'failed to create user: keycloak api error: {"errormessage":"user exists with same username"}':
    "同じユーザーidのユーザーが既に存在します。",
  "first name or last name is required": "姓・名いずれかの入力が必要です。",
  "validation failed: first name or last name is required":
    "姓・名いずれかの入力が必要です。",
  "company home page must be a valid url": "URLの形式が正しくありません。",
  "parent department cannot be itself":
    "親部署に自身を設定することはできません。",
  "apps is required for general role users":
    "一般権限の電話帳には利用アプリが必要です。",
};

// for matching error keywords from backend error messages
export const errorMappings: { keyword: string; message: string }[] = [
  { keyword: "user not found", message: "user not found" },
  { keyword: "company home page", message: "company home page is invalid" },
  { keyword: "couldn't find user", message: "user not found with id" },
  { keyword: "name is invalid", message: "name is invalid" },
  { keyword: "name kana is invalid", message: "name kana is invalid" },
  {
    keyword: "invalidpasswordhistorymessage",
    message: "invalid password: must not be equal to any of last 3 passwords.",
  },
  {
    keyword:
      "can only contain alphanumeric characters, japanese characters, and hyphens",
    message:
      "first name can only contain alphanumeric characters, japanese characters, and hyphens",
  },
  {
    keyword: "failed to open tcp connection",
    message: "tcp connection failed to connect",
  },
  {
    keyword: "already exist yobely Store",
    message: "already exist yobely Store",
  },
  {
    keyword: "not found specified store_id",
    message: "not found specified store_id",
  },
  {
    keyword: "failed to delete yobely store because user assigned to store",
    message: "delete user assigned to store",
  },
  {
    keyword:
      "failed to create broadcast group: name name has already been taken",
    message: "broadcast group name has already been taken",
  },
  {
    keyword: "display order has already been taken",
    message: "display order has already been taken",
  },
  {
    keyword: "already exist yobely company",
    message: "already exist yobely company",
  },
  {
    keyword:
      'duplicate key value violates unique constraint "index_users_on_tenant_id_and_phone_number"',
    message: "user with the same phone number exists in database",
  },
  {
    keyword: "could not obtain a connection from the pool",
    message: "could not obtain a connection from the pool",
  },
  {
    keyword: "depth of broadcast group cannot exceed",
    message: "depth of broadcast group exceeded",
  },
  {
    keyword: "not found specified staff_id",
    message: "not found specified staff_id",
  },
  {
    keyword: "店舗が見つかりません。",
    message: "store not found in hazum",
  },
  {
    keyword: "cannot change user broadcast group to a different one",
    message: "cannot change user broadcast group to a different one",
  },
  {
    keyword: "name name has already been taken",
    message: "tenant department name has already been taken",
  },
  {
    keyword: "failed to update yobely store",
    message: "failed to update yobely store",
  },
  {
    keyword:
      "user with the same last name and first name already exists in the tenant",
    message:
      "user with the same last name and first name already exists in the tenant",
  },
  {
    keyword: "user exists with same email",
    message: "user exists with same email",
  },
  {
    keyword: "error-person-name-invalid-character",
    message: "error-person-name-invalid-character",
  },
  {
    keyword: "company fax invalid phone number format",
    message: "company fax invalid phone number format",
  },
  {
    keyword: "description is too long (maximum is 1000 characters)",
    message: "description is too long (maximum is 1000 characters)",
  },
  {
    keyword: "User exists with same username",
    message: "user exists with same username",
  },
  {
    keyword: "User exists with same email",
    message: "keycloak user exists with same email",
  },
  {
    keyword: "invalidPasswordHistoryMessage",
    message: "invalid password: must not be equal to any of last 3 passwords.",
  },
  {
    keyword: "invalidPasswordMinSpecialCharsMessage",
    message: "invalid password: must contain at least 1 special characters.",
  },
  {
    keyword: "invalidPasswordMinUpperCaseCharsMessage",
    message: "invalid password: must contain at least 1 upper case characters.",
  },
  {
    keyword: "invalidPasswordMinLowerCaseCharsMessage",
    message: "invalid password: must contain at least 1 lower case characters.",
  },
  {
    keyword: "Couldn't find User with ",
    message: "user not found with id",
  },
  {
    keyword: "user exists with same username",
    message: "user exists with same username",
  },
  {
    keyword: "parent department cannot be itself",
    message: "parent department cannot be itself",
  },
  {
    keyword: "apps is required for general role users",
    message: "apps is required for general role users",
  },
  {
    keyword: "invalid password: minimum length",
    message: "invalid password: minimum length",
  },
];
